import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ParseError } from '@angular/compiler';

/**
 * Generated class for the TransDatePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'transDate'
})
export class TransDatePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */

  constructor(private translateService: TranslateService) { }

  transform(value: string, pattern: string = 'mediumDate') {
    if(typeof value == "undefined") return false;
    
    const datePipe: DatePipe = new DatePipe(this.translateService.getDefaultLang());

    const num = Number(value)
    const dateValue = (Number.isNaN(num)) ?new Date(value): new Date(num);

    const dateWithNoTimezone = new Date(
      dateValue.getFullYear(),
      dateValue.getMonth(),
      dateValue.getDate(),
      dateValue.getHours(),
      dateValue.getMinutes(),
      dateValue.getSeconds()
    );

    return datePipe.transform(dateWithNoTimezone, pattern);
  }
}
